var map = {
	"./music-instructions.json": 3352,
	"./music-library-intro2024.json": 3353,
	"./music-library-launch2024.json": 3354,
	"./music-progression.json": 3355,
	"./startSourcesAdvanced.json": 3356,
	"./startSourcesSimple.json": 3357,
	"./startSourcesSimple2.json": 3358,
	"./startSourcesTracks.json": 3359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3045;